import AssetField from '../../../contentful/AssetField';
import update from 'immutability-helper';
import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import EntityCollectionField from '../../../contentful/EntityCollectionField';


class EquipmentGroupComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleIncludedChange = this.handleIncludedChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      equipmentGroup: {}
    };

    change.equipmentGroup[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleIncludedChange(name, asset, action) {
    const change = {
      equipmentGroup: {}
    };

    change.equipmentGroup[name] = {
      $set: asset
    };

    if (action === 'add') {
      const lastAddedAsset = asset[asset.length - 1];

      if (this.props.equipmentGroup[name].some((eg) => eg.id === lastAddedAsset.id)) {
        // Ignore duplicate included items
        return;
      }
    }

    const props = update(this.props, change);

    this.props.onChange(props, action === 'add');
  }

  handleFieldChange(e) {
    return this.handleAssetChange(e.target.name, e.target.value);
  }

  render() {
    const equipmentGroup = this.props.equipmentGroup;
    const typename = this.props.type === 'equipmentFactory' ? 'Ekstrautstyr' : 'Tilbehør';
    const typenameGroup = `${typename}gruppe`;
    const predefinedTags = [this.props.model.make.name, this.props.model.name, typenameGroup];
    const includedFieldName = this.props.type === 'equipmentFactory' ? 'includedFactoryEquipment' : 'includedEquipment';

    return (
      <section className="mf-equipment-equipment">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}`}>{this.props.model.make.name}</Link>
          </li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}/modell/${this.props.model.id}`}>{this.props.model.name}</Link>
          </li>
          <li className="active">{equipmentGroup.name}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>
                  {equipmentGroup.name} <PublishStatusDot entry={equipmentGroup} /><br/>
                  <small>{typenameGroup}</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!equipmentGroup.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    <span>Lagre endringer</span>
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={!(equipmentGroup.draft || equipmentGroup.updated) || this.props.working || this.props.modified || equipmentGroup.archived}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={equipmentGroup.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {!equipmentGroup.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                {equipmentGroup.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnArchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Navn</label>
                <input type="text" className="form-control" name="nameCustom" value={equipmentGroup.nameCustom} disabled={this.props.working || equipmentGroup.archived} onChange={this.handleFieldChange} />
              </div>
              {this.props.type === 'equipment' && <>
                <div className="form-group">
                  <label>Kategori</label>
                  <select
                    type="text"
                    className="form-control"
                    name="category"
                    defaultValue={equipmentGroup.category}
                    disabled={this.props.working || equipmentGroup.archived}
                    onChange={this.handleFieldChange}
                  >
                    <option value="">-- Velg kategori --</option>
                    <option value="Anbefalt tilbehør">Anbefalt tilbehør</option>
                    <option value="Innvendig">Innvendig</option>
                    <option value="Utvendig">Utvendig</option>
                    <option value="Dekk">Dekk</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Prioritet</label>
                  <input type="text" className="form-control" name="priority" defaultValue={equipmentGroup.priority} disabled={this.props.working || equipmentGroup.archived} onChange={this.handleFieldChange}/>
                </div>
              </>}

              {this.props.type === 'equipmentFactory' && <>
                <div className="form-group">
                  <label>Varianter</label>
                  <EntityCollectionField
                    name="variantWhitelistManual"
                    value={equipmentGroup.variantWhitelistManual}
                    contentType="variant"
                    searchParams={{
                      'fields.model.sys.id': this.props.model.id
                    }}
                    searchOnOpen={true}
                    allowEdit={true}
                    onChange={this.handleAssetChange}
                    disabled={this.props.working || equipmentGroup.archived }
                  />
                </div>
                <div className="form-group">
                  <label>Kun utvalgte forhandlere</label>
                  <EntityCollectionField
                    name="dealerWhitelist"
                    value={equipmentGroup.dealerWhitelist}
                    contentType="forhandler"
                    searchParams={{
                      'fields.makes.sys.id[in]': this.props.model.make.id
                    }}
                    quickAdd={true}
                    onChange={this.handleAssetChange}
                    disabled={this.props.working || equipmentGroup.archived }
                  />
                </div>
              </>}

            </div>
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Bilde</label>
                <AssetField
                  name="image"
                  value={equipmentGroup.image}
                  onChange={this.handleAssetChange}
                  disabled={this.props.working || equipmentGroup.archived}
                  predefinedTags={predefinedTags}
                />
              </div>
            </div>
            <div className="col-xs-12">
              <div className="form-group">
                <label>{typename}</label>
                <EntityCollectionField
                  name={includedFieldName}
                  value={equipmentGroup[includedFieldName]}
                  contentType={this.props.type}
                  searchParams={{
                    'fields.model.sys.id': this.props.model.id,
                    'fields.group[ne]': true
                  }}
                  searchOnOpen={true}
                  quickAdd={true}
                  onChange={this.handleIncludedChange}
                  disabled={this.props.working || equipmentGroup.archived }
                />
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default EquipmentGroupComponent;
